export default __webpack_public_path__ + "static/media/img-0514-croatia-half-face.1748c487.png";